"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useHackilyHideRestOfPopoutPage;
var _react = require("react");
var _modes = require("../constants/modes");
/**
 * This hook will, (once the callback is passed the ref to the debugPanelNode mounted in the DOM)
 * hide all of the debug panel's siblings.
 *
 * We use useCallback here the same way we used to use componentWasMounted + refs
 *
 * This is a hacky quick-and-dirty way to hide the other things going on on the page, since we just
 * duplicate the page in order to create the "popout" window. This helps take care of things like creative divs demanding focus and hopefully lessens the CPU load (until we have a proper popout mechanism like a blob or extension)
 *
 * @export
 * @param {String} mode If it's not === MODES.POPOUT, this hook won't do anything
 * @returns {Function} Callback that should be passed as a callback ref
 */
function useHackilyHideRestOfPopoutPage(mode) {
  return (0, _react.useCallback)(function (debugPanelNode) {
    if (mode !== _modes.MODES.POPOUT) {
      return;
    }
    if (!debugPanelNode) {
      return;
    }
    Array.from(debugPanelNode.parentNode && debugPanelNode.parentNode.childNodes || []).forEach(function (siblingNode) {
      if (siblingNode !== debugPanelNode) {
        siblingNode.style.display = 'none';
        siblingNode.style.pointerEvents = 'none';
      }
    });
  });
}